import React, { ReactElement, useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ToolSelector } from "./ToolSelector";
import { ToolContainer } from "./ToolContainer";
import { ProgressIndicator } from "./ProgressIndicator";
import { ModelLoadProgress } from "./MobileQwen3Manager";  // ADDED
import Footer from "./atoms/footer";

interface WorkspaceProps {  // FIXED: "WorkspacePropes" → "WorkspaceProps"
  isDark?: boolean;
  modelProgress?: ModelLoadProgress | null;  // ADDED
  modelReady?: boolean;                      // ADDED
}

export function Workspace({ 
  isDark, 
  modelProgress = null,   // ADDED
  modelReady = false      // ADDED
}: WorkspaceProps): ReactElement {
  const [selectedTool, setSelectedTool] = useState<string | null>(null);
  const location = useLocation();

  // Use sessionStorage to persist a flag across page refreshes
  const [didStartDhp, setDidStartDhp] = useState<boolean>(() => {
    // On initial mount, check sessionStorage
    const storedVal = sessionStorage.getItem("didStartDhp");
    return storedVal === "true"; // If it's "true", we've already started DHP
  });

  return (
    <div
      className=" enliveWorkspace"
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        position: "relative", // So absolutely/fixed-positioned children can anchor to this container
      }}
    >
      {/* The ProgressIndicator pinned to the bottom-right corner */}
      <div
        style={{
          position: "absolute", // Changed from "fixed" to "absolute" so it scrolls with content
          top: "1px",
          right: "1px",
          zIndex: 999, // Make sure it sits above other elements
        }}
      >
        <ProgressIndicator 
          theme={isDark ? "dark" : "light"} 
          modelProgress={modelProgress}   // ADDED
          modelReady={modelReady}          // ADDED
        />
      </div>

      {selectedTool === null && (
        <ToolSelector
          className="enliveToolSelector"
          onToolSelect={setSelectedTool}
        />
      )}
      {selectedTool !== null && (
        <ToolContainer
          className=""
          selectedTool={selectedTool}
          setSelectedTool={setSelectedTool}
          isDark={isDark}
        />
      )}

      {location.pathname === "/workspace" && selectedTool === null && (
        <div
          style={{
            marginTop: "auto",
            textAlign: "center",
            padding: "10px",
            fontSize: "14px",
            marginBottom: "60px", // So the bottom links don't overlap the circle
          }}
        >
          <Link to="/privacypolicy" className="me-3">
            Privacy Policy
          </Link>
          <Link to="/termsofuse">Terms of Use</Link>
        </div>
      )}
      {selectedTool === null && <Footer />}
    </div>
  );
}

// END //
